import {
  getCollectionsSuccess,
  getCollectionsFailure,
  getCollectionsByCompany,
  addCollectionStart,
  addCollectionSuccess,
  addCollectionFailure,
  editCollectionStart,
  editCollectionSuccess,
  editCollectionFailure,
  fetchCollectionDetailsStart,
  fetchCollectionDetailsSuccess,
  setSelectedCollectionID,
  resetCollectionDetails,
  // drive actions
  getCollectionDrivesStart,
  getCollectionDrivesSuccess,
  getCollectionDrivesFailure,
  addDriveStart,
  addDriveSuccess,
  addDriveFailure,
  removeDriveStart,
  removeDriveSuccess,
  removeDriveFailure,
  resetSnackbar,
  setFilteredCollectionList,
  getCollectionsStart,
  setDatasetID,
  resetDatasetID,
} from './collection.slice';
import {
  getAllCollectionsByCompanyApi,
  createCollectionApi,
  updateCollectionApi,
  getCollectionDetailsApi,
  addDriveToCollectionApi,
  removeDriveFromCollectionApi,
  fetchDatasetsForCollectionApi,
} from '../api/collection.api';
import { fetchDrives } from '../../drive/api/drive.api';

export const fetchAllCollections = (companyid) => async (dispatch) => {
  dispatch(getCollectionsStart());
  try {
    const response = await getAllCollectionsByCompanyApi(companyid);
    dispatch(getCollectionsSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(getCollectionsFailure(error.response?.data));
  }
};

export const fetchCollectionsByCompany = (companyid) => async (dispatch) => {
  dispatch(getCollectionsStart());
  const response = await getAllCollectionsByCompanyApi(companyid);
  dispatch(getCollectionsByCompany(response.data));
};

export const addCollection = (collectionData) => async (dispatch) => {
  dispatch(addCollectionStart());
  try {
    // Create collection instead of job
    const response = await createCollectionApi(collectionData);
    dispatch(addCollectionSuccess(response.data));
  } catch (error) {
    dispatch(addCollectionFailure(error.response?.data));
  }
};

export const editCollection = (collectionData) => async (dispatch) => {
  dispatch(editCollectionStart());
  try {
    // Update collection instead of job
    const response = await updateCollectionApi(collectionData);
    dispatch(editCollectionSuccess(response.data));
  } catch (error) {
    dispatch(editCollectionFailure(error.response?.data));
  }
};

export const getCollectionDetails = (collectionId) => async (dispatch) => {
  dispatch(fetchCollectionDetailsStart());
  const collection = await getCollectionDetailsApi(collectionId);
  dispatch(fetchCollectionDetailsSuccess(collection.data));
};

export const setCollectionID = (collectionId) => async (dispatch) => {
  dispatch(setSelectedCollectionID(collectionId));
};

export const resetCollection = () => async (dispatch) => {
  dispatch(resetCollectionDetails());
};

export const resetSnackbarDetails = () => async (dispatch) => {
  dispatch(resetSnackbar());
};

export const setFilteredCollections = (collections) => async (dispatch) => {
  dispatch(setFilteredCollectionList(collections));
};

export const addDriveToCollection = (collectionId, driveIds) => async (dispatch) => {
  dispatch(addDriveStart());
  try {
    const response = await addDriveToCollectionApi(collectionId, driveIds);
    dispatch(addDriveSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(addDriveFailure(error.response?.data));
  }
};

export const removeDriveFromCollection = (collectionId, driveIds) => async (dispatch) => {
  dispatch(removeDriveStart());
  try {
    const response = await removeDriveFromCollectionApi(collectionId, driveIds);
    dispatch(removeDriveSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(removeDriveFailure(error.response?.data));
  }
};

export const fetchCollectionDrives = (collectionId) => async (dispatch) => {
  dispatch(getCollectionDrivesStart());
  try {
    const response = await fetchDrives(collectionId);
    dispatch(getCollectionDrivesSuccess(response));
    return response;
  } catch (error) {
    dispatch(getCollectionDrivesFailure(error.response?.data));
  }
};

export const fetchDatasetsForCollection = (collectionId) => async (dispatch) => {
  try {
    const response = await fetchDatasetsForCollectionApi(collectionId);
    dispatch(setDatasetID(response.data.data));
  } catch (error) {
    dispatch(setDatasetID(null));
  }
};

export const resetDatasetIDAction = () => async (dispatch) => {
  dispatch(resetDatasetID());
};
